module.exports = __webpack_public_path__ + "static/media/12.62843e17.jpg";